import {
  type UserOrderResponseWithFlagsSubOrdersInner,
  type UserSubOrderV2,
} from '@redteclab/api/clients/bully'

export const userSubOrderAccessorIsSelfService = (
  subOrder: UserOrderResponseWithFlagsSubOrdersInner | UserSubOrderV2,
): boolean => {
  if (subOrder.orderDocuments) {
    return subOrder.orderDocuments.some((doc) =>
      doc.documentPositions?.some((position) => position.isClaimable),
    )
  }
  if (subOrder.orderDocumentsERx) {
    return subOrder.orderDocumentsERx.some((doc) =>
      doc.documentPositions?.some((position) => position.isClaimable),
    )
  }

  return false
}
